import EnterpriseHeader from "./EnterpriseHeader";

export default EnterpriseHeader;
